<template>
    <v-container>
        <v-row>
            <v-col>
                <v-toolbar dense flat rounded="" color="secondary" outlined elevation="1">
                    <v-breadcrumbs class="ms-n6" :items="[{text: 'Warehouse & inventory'}, {text: 'Warehouse'} ,{text: 'Measure Units List',}]" large/>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-sheet elevation="1">
                    <v-toolbar color="secondary" flat>
                        <v-toolbar-title>
                            Measure Unit
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <PIconBtn icon="mdi-plus" tooltip="New Measure Unit" v-if="hasPermission(perm.measure_unit.create)" @click="handleNew"/>
                            <PIconBtn icon="mdi-refresh" tooltip="Refresh" @click="search"/>
                            <v-menu 
                                offset-y
                                :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        color="primary"
                                        v-bind="attrs"
                                        v-on="on"
                                        icon
                                        >
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-btn>
                                </template>
                                <v-card 
                                    flat
                                    >
                                    <v-card-title>Search</v-card-title>
                                    <v-card-text>
                                        <MeasureUnitListSearch ref="form"/>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-btn  color="primary" block @click="$refs.form.submit()">Submit</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-menu>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <MeasureUnitList/>
                </v-sheet>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import MeasureUnitListSearch from './../../components/warehouse/MeasureUnitListSearch.vue'
import MeasureUnitList from './../../components/warehouse/MeasureUnitList.vue'
import PIconBtn from './../../components/common/PIconBtn.vue';
import permissions from './../../data/permissions'
import { mapActions,mapGetters } from 'vuex';
export default {
    name: "MeasureUnitListView",
    components: {
        PIconBtn,
        MeasureUnitList,
        MeasureUnitListSearch
    },
    data() {
        return {
            perm: permissions 
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        handleNew() {
            this.$router.push({ name: "MeasureUnitCreate"})
        },
        ...mapActions({
            search: "warehouse/measureUnit/list/get"
        }),
    }
}
</script>

<style>
</style>